export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-wheelchair-f09ce929b3e6530ab976aa03d9007b3d.svg";